var _path, _rect, _circle, _circle2, _circle3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 238,
    viewBox: "0 0 241 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.235 127.57H66.2952C64.1454 127.57 62.2108 126.274 61.3916 124.284C60.58 122.297 61.0557 120.036 62.5788 118.52L108.308 73.5771H66.2952C63.3697 73.5771 61.0066 71.1857 61.0066 68.2885C61.0085 65.3555 63.3716 63 66.2952 63H121.235C123.381 63 125.319 64.3004 126.129 66.2898C126.944 68.2772 126.469 70.5402 124.946 72.0521L79.2167 116.999H121.237C124.153 116.999 126.525 119.379 126.525 122.288C126.524 125.215 124.144 127.57 121.235 127.57ZM182.79 138.434H156.908L186.518 109.33C188.051 107.807 188.502 105.556 187.707 103.568C186.895 101.581 184.94 100.271 182.792 100.271H143.971C141.068 100.271 138.683 102.64 138.683 105.557C138.683 108.455 141.068 110.846 143.971 110.846H169.869L140.257 139.942C138.713 141.471 138.26 143.714 139.073 145.707C139.892 147.711 141.821 149.012 143.971 149.012H182.788C185.712 149.012 188.077 146.635 188.077 143.723C188.077 140.809 185.712 138.434 182.79 138.434ZM123.096 183.425H105.043L126.805 162.046C128.341 160.538 128.806 158.254 127.994 156.265C127.179 154.279 125.24 152.979 123.094 152.979H92.1211C89.2013 152.979 86.8306 155.353 86.8306 158.267C86.8306 161.178 89.2013 163.556 92.1211 163.556H110.175L88.4085 184.931C86.8759 186.46 86.4078 188.702 87.2251 190.695C88.0386 192.688 89.9732 194 92.123 194H123.098C126.018 194 128.385 191.624 128.385 188.711C128.385 185.799 126.039 183.425 123.096 183.425Z",
    fill: "#E0E5E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 233,
    height: 230,
    rx: 8,
    stroke: "#E0E5E8",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7545,
    cy: 30.7724,
    r: 4.75446,
    fill: "#DADADA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.774,
    cy: 30.7724,
    r: 4.75446,
    fill: "#DADADA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7896,
    cy: 30.7724,
    r: 4.75446,
    fill: "#DADADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3184,
    y: 27.2065,
    width: 130.748,
    height: 7.13169,
    rx: 3,
    fill: "#E0E5E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.0e9bfc6783fbe3982a75b796284d1107.svg";
export { ForwardRef as ReactComponent };